require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-cloudthing-is-shortlisted-finalists-at-the-computing-devops-excellence-awards-2019.json") })
        }
      }, "path---blog-cloudthing-is-shortlisted-finalists-at-the-computing-devops-excellence-awards-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-cloudthing-is-shortlisted-finalists-at-the-computing-devops-excellence-awards-2019!./.cache/json/blog-cloudthing-is-shortlisted-finalists-at-the-computing-devops-excellence-awards-2019.json
// module id = 814
// module chunks = 231608221292675